import React, { useEffect, useRef, useState } from "react";
import Highcharts from "highcharts";
import "highcharts/modules/exporting";
import "highcharts/modules/no-data-to-display";
import "highcharts/modules/boost";
import { Chart, setHighcharts } from "@highcharts/react";
import { commonConstants } from "../../../constants";
import loadingImage from "../../../assets/images/loading.svg";
import PropTypes from "prop-types";

setHighcharts(Highcharts);

const MultiChart = ({ chart_data, chart_type, title, height, loading }) => {
  const chartRef = useRef(null);
  const [options, setOptions] = useState(null);

  const setChartOptions = ({ chart_data, chart_type, title, height }) => {
    /* let chartData = [];
    if (!isEmpty(chart_data)) {
      //chartData = chart_data.map((row) => [UTCTimeStampToLocal(row.ts), row.pvl]);
      chartData = chart_data;
    } */

    const chartType = chart_type === commonConstants.chartType.BAR ? "column" : "line";
    setOptions({
      title: { text: "" },
      chart: {
        height: height ? height : null,
        type: chartType,
        zoomType: "x",
        panning: true,
        panKey: "shift",
        backgroundColor: "transparent",
        borderColor: null,
        borderWidth: 0,
        plotBackgroundColor: "transparent",
        plotBorderWidth: 0,
      },
      xAxis: {
        type: "datetime",
      },
      rangeSelector: {
        selected: 4,
      },

      yAxis: {
        title: { text: title },
        gridLineColor: "transparent",
        plotLines: [
          {
            value: 0,
            width: 2,
            color: "silver",
          },
        ],
      },

      plotOptions: {
        series: {
          compare: "percent",
          showInNavigator: true,
        },
      },

      tooltip: {
        shared: true,
        formatter: function () {
          let tooltip = `<b>${Highcharts.dateFormat("%A, %b %e, %Y %H:%M:%S", this.x)}</b><br/>`;
          this.points.forEach((point) => {
            tooltip += `<span style="color:${point.series.color}">\u25CF</span> ${point.series.name}: <b>${point.y} ${point.series.userOptions.unit}</b><br/>`;
          });
          return tooltip;
        },
        borderWidth: 1,
        shadow: false,
      },
      series: chart_data,
      credits: { enabled: false },
      exporting: {
        buttons: {
          contextButton: {
            menuItems: ["downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG"],
          },
        },
      },
      noData: { style: { fontSize: "16px" } },
      animation: false,
      navigation: {
        buttonOptions: { verticalAlign: "bottom", y: -0 },
      },
      loading: { style: { backgroundColor: "transparent", opacity: 1 } },
    });
  };

  useEffect(() => {
    if (chartRef.current) {
      const chartObj = chartRef.current.chart;
      if (loading === false) chartObj.hideLoading();
      else chartObj.showLoading(`<img src="${loadingImage}" />`);
    }
  }, [loading]);

  useEffect(() => {
    setChartOptions({ chart_data, chart_type, title, height });
  }, [chart_data, chart_type, title, height]);

  return (
    <React.Fragment>
      {options && <Chart ref={chartRef} options={options} />}
    </React.Fragment>
  );
};

export default MultiChart;

// PropTypes validation
MultiChart.propTypes = {
  chart_data: PropTypes.array,
  chart_type: PropTypes.number,
  title: PropTypes.string,
  height: PropTypes.string,
  loading: PropTypes.any,
};
